import withLoader from "../../../../components/layouts/WithLoader";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import PayementRHService from "../../../../services/RHService/PayementRHService";
import DataFicheDePaieList from "./DataFicheDePaieList";

const AddNewSalaire = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const [selectedOption, setSelectedOption] = useState(null);
  const [yearSelected, setYearSelected] = useState(null);
  const [yearSelectedOption, setYearSelectedOption] = useState(null);
  const [allYears, setAllYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [monthPlaceholder, setMonthPlaceholder] = useState("Choisir...");
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [finalMonth, setFinalMonth] = useState("");

  const [listFicheDePaie, setListFicheDePaie] = useState([]);

  const [yearSelectPlaceHolder, setYearSelectPlaceHolder] =
    useState("Choisir...");

  useEffect(() => {
    setAllYears([]);
    var currentYear = new Date().getFullYear();

    var lastyear = currentYear - 1;
    setAllYears((oldArray) => [
      ...oldArray,
      { value: lastyear, label: lastyear },
    ]);
    setAllYears((oldArray) => [
      ...oldArray,
      { value: currentYear, label: currentYear },
    ]);
    var newyear = currentYear + 1;
    setAllYears((oldArray) => [
      ...oldArray,
      { value: newyear, label: newyear },
    ]);
    setMonthsOptions([]);
    setMonthsOptions([
      { value: "1", label: "Janvier" },
      { value: "2", label: "Février" },
      { value: "3", label: "Mars" },
      { value: "4", label: "Avril" },
      { value: "5", label: "Mai" },
      { value: "6", label: "Juin" },
      { value: "7", label: "Juillet" },
      { value: "8", label: "Aout" },
      { value: "9", label: "Septembre" },
      { value: "10", label: "Octobre" },
      { value: "11", label: "Novembre" },
      { value: "12", label: "Decembre" },
    ]);
  }, []);
  const onChangeSelectedYear = (selectedOptionn) => {
    setSelectedOption();
    setYearSelected(selectedOptionn.value);
    localStorage.setItem("yearRH", selectedOptionn.value);
    setYearSelectPlaceHolder(selectedOptionn.label);
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
    localStorage.setItem("monthRH", selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const listePayementsRH = (e) => {
    startLoading();
    PayementRHService.getSalaireBySociete(
      getCurrentUserId(),
      finalMonth,
      yearSelected
    )
      .then((response) => {
        console.log(response);
        if (response.data["error"]) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :  " + response.data["error"]);
        } else {
          setListFicheDePaie(response?.data?.success);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :  " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">Salaire</div>
          </div>
        </div>
      </section>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-header">
              <h3 className="card-title"> Payer le salaire</h3>
            </div>

            <div class="card-body">
              <div className="row">
                <div class="form-group col-sm-3">
                  <div>
                    <label>Choisir l'année </label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={yearSelectedOption}
                      onChange={onChangeSelectedYear}
                      options={allYears}
                      placeholder={yearSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="form-group col-sm-3">
                  <div>
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      defaultValue={selectedMonth}
                      placeholder={monthPlaceholder}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                class="btn btn-dark  float-right"
                onClick={listePayementsRH}
              >
                Voir Fiche de paie
              </button>
            </div>
          </div>
        </div>
      </section>
      {listFicheDePaie && listFicheDePaie.length !== 0 && (
        <section className="content-header">
          <div className="container-fluid">
            <DataFicheDePaieList listFicheDePaie={listFicheDePaie} />
          </div>
        </section>
      )}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddNewSalaire);
